import { WelcomeListProps } from '@bitte-ai/types';
import { cn } from '../../../lib/utils';

export const WelcomeList: React.FC<WelcomeListProps> = ({
  items,
  label,
  bgColor,
  onItemClick,
}) => {
  if (!items?.length) return null;

  return (
    <div className="bitte-flex bitte-gap-2 bitte-flex-col">
      <p
        className={cn(
          'bitte-text-[10px] bitte-uppercase bitte-font-semibold',
          'bitte-text-[#969696]',
        )}
      >
        {label}
      </p>
      <div className="bitte-flex bitte-gap-2 bitte-flex-col">
        {items.map((item, index) => (
          <button
            key={index}
            type="button"
            className={cn(
              'bitte-p-2 bitte-w-fit bitte-rounded-md bitte-text-xs',
              'cursor-pointer hover:bitte-opacity-80 bitte-transition-opacity',
              'bitte-text-left bitte-border-none',
            )}
            style={{ backgroundColor: bgColor }}
            onClick={() => onItemClick(item)}
          >
            {item}
          </button>
        ))}
      </div>
    </div>
  );
};
